import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Card, CardBody, Form, Button, Spinner } from "react-bootstrap";
import axios from 'axios';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useVehicleActivities } from '../../../auth/useVehicleActivities';
import { useAuth, useApiPost, useFetch, useBasepathUrl } from "../../../hooks";
import { SuccessToolbar, ErrorToolbar } from "../../../lib/formControls";
import { snglDateRngFormat, snglDateFormat } from "../../Common/appHelper";
import { apiUrl } from "../../../lib/appConfig";
import CameraListView from "./CameraListView";
import CameraGridView from "./CameraGridView";
import VehicleListView from "./VehicleListView";
import VehicleListViewApi from "./VehicleListViewApi";

import listVw from "../../../common/images/listVw.png";
import listActVw from "../../../common/images/listActVw.png";
import gridVw from "../../../common/images/gridVw.png";
import gridActVw from "../../../common/images/gridActVw.png";
import eyeIcon from "../../../common/images/eyeWtIcon.png";

import DatePicker from "react-datepicker";
const DateFilter = ({ selectedDate, onChange }) => {
  return (
    <Form.Group controlId="dateFilter">
      <DatePicker
        selected={selectedDate}
        onChange={onChange}
        dateFormat="dd MMM yyyy"
        className="form-control custom-datepk-input"
      />
    </Form.Group>
  );
};

const formatToISOZ = (dateStr) => {
  if (!dateStr) return null;

  const trimmed = dateStr.split(".")[0] + "." + dateStr.split(".")[1]?.slice(0, 3);
  return trimmed + "Z";
};

export default function PetrolBunkDetail() {
    const navigate = useNavigate();
    const basePage = useBasepathUrl(2);
    const { recordId } = useParams();

    const pollingRef = useRef(null);

    const roleKey = localStorage.getItem("roleKey");
    const entityIdVal = localStorage.getItem("entityId");
    let entityId = '';
    if(roleKey === 'bunk_incharge') {
      if(entityIdVal != "") {
            entityId = entityIdVal;
      } else {
           navigate('/');
      }
    } else {
      entityId = recordId;
    }
    const [bunkData, setBunkData] = useState(null);
    const [userData, setUserData] = useState(null);
    const [cameraData, setCameraData] = useState(null);
    const [vehicleData, setVehicleData] = useState(null);
    const [fetchUserUrl, setFetchUser] = useState(null);
    const [fetchCameraUrl, setFetchCameraUrl] = useState(null);
    const [totalInvehicle, setTotalInvehicle] = useState(0);
    const [totalOutvehicle, setTotalOutvehicle] = useState(0);
    const [customerror, setCustomerror] = useState('');
    const [showVehicleList, setShowVehicleList] = useState(false);
    const [colwdt, setColwdt] = useState(12);
    const [vchlLoading, setVchlLoading] = useState(false);
    const [vchlIntrvlLoading, setVchlIntrvlLoading] = useState(false);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [activeView, setActiveView] = useState('list');
    const { authToken } = useAuth();

    const { vehicleactivities, isLoading, error } = useVehicleActivities(entityId,selectedDate);
    console.log('vehicleactivities123', vehicleactivities);

    const { postData: fetchBunk, loading: fetchbunkLoading } = useApiPost(`entities/get-by-id`, authToken);
    const { data: userResData, loading: edituserLoading, error: eduserError } = useFetch(fetchUserUrl, authToken);
    const { data: camereResData, loading: cameraLoading, error: cameraError } = useFetch(fetchCameraUrl, authToken);

    const isToday = (date) => {
            const today = new Date();
            return (date?.toDateString() === today.toDateString());
    };
    
    useEffect(() => {
              const fetchBunkData = async () => {
                  const payload = JSON.stringify({id:entityId});
                  const { result, error } = await fetchBunk(payload);
                  if (result?.data) {
                  let resData = result?.data;
                  setBunkData(resData);
                  } else {
                  setCustomerror(error || 'Failed to fetch bunk data');
                  }
              };
          
              if(entityId != '') {
                  fetchBunkData();
                  let userUrlTxt = `${apiUrl}users?filter=roleKey|bunk_incharge%26entityIds|${entityId}`;
                  setFetchUser(userUrlTxt);
                  let cameraUrlTxt = `${apiUrl}camera?filter=entityId|${entityId}`;
                  setFetchCameraUrl(cameraUrlTxt);
                  fetchVehicleData();
              }
      }, []);
      
      useEffect(() => {
          if(userResData?.data) {
              if(userResData?.data[0]) {
                let userResDataObj = userResData?.data[0];
                setUserData(userResDataObj);
              }
          }
      }, [userResData]);

      useEffect(() => {
          if(camereResData?.data) {
              setCameraData(camereResData?.data);
          }
      }, [camereResData]);


      useEffect(() => {
            const shouldPoll = isToday(selectedDate) && (!vehicleactivities || vehicleactivities.length === 0);

            // START polling
            if (shouldPoll && !pollingRef.current) {
                  console.log("🚀 Start polling vehicle API every 5s");

                  pollingRef.current = setInterval(() => {
                        if (!vchlIntrvlLoading) fetchVehicleData('interval');
                  }, 10000);
            }

            // STOP polling when data arrives
            if(vehicleactivities?.length > 0 && pollingRef.current) {
                  console.log("🛑 Stop polling — data received");
                  clearInterval(pollingRef.current);
                  pollingRef.current = null;
            }

            // Cleanup on date change / unmount
            return () => {
                  if(pollingRef.current) {
                        clearInterval(pollingRef.current);
                        pollingRef.current = null;
                  }
            };
      }, [vehicleactivities, selectedDate]);

      function getToday() {
            return new Date().toISOString().split('T')[0]
      }

      useEffect(() => {
            fetchVehicleData();
      }, [selectedDate]);

     useEffect(() => {
            let inCount = 0;
            let outCount = 0;
            if (vehicleactivities?.length) {
                  const outResultData = vehicleactivities.map((item) => {

                        if (item.in_time) inCount++;
                        if (item.out_time) outCount++;

                        const inTime = item.in_time ? formatToISOZ(item.in_time) : null;

                        const outTime = item.out_time ? formatToISOZ(item.out_time) : null;

                        const createdAt = item.created_at ? formatToISOZ(item.created_at) : null;

                        return {
                        id: item.id,
                        vehicleId: item.vehicle_id,
                        entityId: item.entity_id,
                        inTime: inTime,
                        outTime: outTime,
                        fuel: item.fuel,
                        fuelQuantityLitre: item?.fuel_quantity_litre,
                        amount: item.amount,
                        userId: item.user_id,
                        status: item.status,
                        paymentType: item.payment_type,
                        paymentStatus: item.payment_status,
                        createdAt: item.created_at,
                        updatedAt: item.updated_at,

                        vehicleNo: item.vehicle_no,
                        type: item.type,
                        model: item.model,
                        category: item.category,
                        ownerName: item.owner_name,
                        phone: item.phone,
                        email: item.email,
                        fuelType: item.type ?? null,
                        totalLitres: item?.fuel_quantity_litre,
                        totalAmount: item.total_amount,
                        };
                  });
                  console.log('outResultData678', outResultData);
                  setVehicleData(outResultData);
            }
            setTotalInvehicle(inCount);
            setTotalOutvehicle(outCount);
      }, [vehicleactivities]);
 

    
     const fetchVehicleData = async (actFrom='selectivecall') => {
            if(actFrom === 'interval') {
               setVchlIntrvlLoading(true);
            } else {
               setVchlLoading(true);
            }
            
            try {
                  const apiUrllnk = apiUrl + 'vehicle-activities';
                  let filterTxt = `entityId|${entityId}`;
                  if(selectedDate) {
                        let selectedDateObj = snglDateRngFormat(selectedDate);
                        if(selectedDateObj?.formatteddateTimeRng) {
                              let startDate = selectedDateObj?.formatteddateTimeRng?.startDate;
                              let endDate = selectedDateObj?.formatteddateTimeRng?.endDate;
                              filterTxt = filterTxt+'&startTime|'+startDate+'&endTime|'+endDate;
                        }
                  }
                  const response = await axios.get(apiUrllnk, {
                  params: {
                  page: 1,
                  limit: 100,      
                  order: 'DESC',      
                  filter: filterTxt,
                  },
                  headers: {
                  Authorization: `Bearer ${authToken}`,
                  },
                  });

                  const responseData = response.data;
                  
                  setVehicleData(responseData?.data || []);
                  setTotalInvehicle(responseData?.total_in_vehicles || 0);
                  setTotalOutvehicle(responseData?.total_out_vehicles || 0);
            } catch (error) {
                  console.error('Error fetching data:', error);
                  let resData = error?.response?.data;
                  let errorMsg = (resData?.message) ? resData?.message : 'Error fetching data';
            } finally {
                  setVchlLoading(false);
                  setVchlIntrvlLoading(false);
            }
     }; 

    const handleDateChange = (date) => {
          setSelectedDate(date);
    };  

    const handleCameraView = (actFrom) => {
          setActiveView(actFrom)
    }

    const handleVehiclelist = (actFrom) => {
          let showvcltxt = false;
          let colmdVal = 12;
          if(actFrom === 'open') {
              showvcltxt = true;
              colmdVal = 6;
          }
          setShowVehicleList(showvcltxt);
          setColwdt(colmdVal);
    }

    const goBackToMain = () => {
            navigate(basePage);
    }

    return (<div className="petrolbunk-detail-page">
          <Container fluid>
            {(roleKey === 'bunk_incharge')?<div className='page-title-main'>
              <h5 className='page-title'>Camera Management</h5>
              <p className='page-info'>Monitor real-time entry and exit camera feeds across petrol bunks.</p>
            </div>:<div className='innerpage-breadcrumb-main'>
              <ul className='breadcrumb-ul'> <li onClick={() => goBackToMain()}>Petrol Bunk Management</li><li>Petrol Bunk Details</li> </ul>
            </div>} 
            <div className='page-content-main'>
                 

                  {/*roles.length === 0 ? (
                  <p>No roles found. Add one to get started!</p>
                  ) : (
                  <div className='col-md-4'>
                        {roles.map((role) => (
                        <div key={role.id} >
                        <div>
                              <h3>{role.name}</h3>
                              <span>{role.role_key}</span>
                        </div>
                        <p>{role.description}</p>
                        <div>
                              <span>
                              Created: {new Date(role.created_at).toLocaleDateString()}
                              </span>
                        </div>
                        </div>
                        ))}
                  </div>
                  )*/}

                 <Card className='card-nobarder mb-2 p-1 card-min-hd'>
                        <CardBody>
                              {(roleKey !== 'bunk_incharge')&&<div className='bunkanduser-info-main'>
                                    <Row>
                                        <Col xs={12} sm={12} md={6} className='col-bdr-right'>
                                              <div className='bunkinfo-top'>
                                                    <h6>{bunkData?.name}</h6>
                                                    <p>{(bunkData?.address1) && bunkData?.address1+', '} {(bunkData?.address2) && bunkData?.address2+', '}
                                                       {(bunkData?.district) && bunkData?.district+', '} {(bunkData?.state) && bunkData?.state+' '} 
                                                       {(bunkData?.pincode) && '- '+bunkData?.pincode}</p>
                                              </div>
                                              <Row className='bunkinfo-btm'>
                                                    <Col xs={12} sm={4} md={4}>
                                                          <div className='info-lable'>No. of Cameras</div>
                                                          <div className='info-value'>{(cameraData)?Object.keys(cameraData).length:0}</div>
                                                    </Col>
                                                    <Col xs={6} sm={4} md={4} className='text-center'>
                                                          <div className='info-lable'>No. of IN Vehicles</div>
                                                          <div className='info-value'>{totalInvehicle}</div>
                                                    </Col>
                                                    <Col xs={6} sm={4} md={4} className='text-end pe-4'>
                                                          <div className='info-lable'>No. of OUT Vehicles</div>
                                                          <div className='info-value'>{totalOutvehicle}</div>
                                                    </Col>
                                              </Row>
                                        </Col>
                                        <Col xs={12} sm={12} md={6}>
                                              <Row className='userinfo-top mb-4'>
                                                  <Col xs={6} sm={6} md={6} className='ps-4'>
                                                          <div className='info-lable'>Incharge Name</div>
                                                          <div className='info-value'>{userData?.firstName} {userData?.lastName}</div>
                                                    </Col>
                                                    <Col xs={6} sm={6} md={6} className='text-end'>
                                                          <div className='info-lable'>Gender</div>
                                                          <div className='info-value'>{userData?.gender}</div>
                                                    </Col>
                                              </Row>
                                              <Row className='userinfo-btm'>
                                                  <Col xs={6} sm={6} md={6} className='ps-4'>
                                                          <div className='info-lable'>Incharge Contact No.</div>
                                                          <div className='info-value'>{userData?.phone}</div>
                                                    </Col>
                                                    <Col xs={6} sm={6} md={6} className='text-end'>
                                                          <div className='info-lable'>Incharge Email</div>
                                                          <div className='info-value'>{userData?.email}</div>
                                                    </Col>
                                              </Row>
                                        </Col>
                                    </Row>
                              </div>}

                              <div className='camera-view-main'>
                                   <div className='camera-view-inner'>
                                        <Row>
                                          <Col md={colwdt}>
                                          <div className='camera-view-filter'>
                                              <Row>
                                                <Col xs={6} sm={6} md={6}>
                                                  <DateFilter selectedDate={selectedDate} onChange={handleDateChange} />
                                                </Col>
                                                <Col xs={6} sm={6} md={6} className='text-end'>
                                                    <div className='grid-list-act'>
                                                          <div className={(activeView === 'grid')?'grid-vw-icon active':'grid-vw-icon'} onClick={() => handleCameraView('grid')}>
                                                            <img className='grid-icon' src={gridVw} alt='gd' />
                                                            <img className='grid-act-icon' src={gridActVw} alt='gd' />
                                                          </div>
                                                          <div className={(activeView === 'list')?'list-vw-icon active':'list-vw-icon'} onClick={() => handleCameraView('list')}>
                                                            <img className='list-icon' src={listVw} alt='ls' />
                                                            <img className='list-act-icon' src={listActVw} alt='ls' />
                                                          </div>
                                                    </div>
                                                </Col>
                                              </Row>
                                          </div>

                                          {(activeView === 'list') && <div className='camere-listview-main'>
                                                <CameraListView cameraData={cameraData} />
                                          </div>}

                                          {(activeView === 'grid') && <div className='camere-gridview-main'>
                                                <CameraGridView cameraData={cameraData} />
                                          </div>}

                                        </Col>
                                        {(showVehicleList) && <Col md={colwdt}>
                                              <VehicleListViewApi handleAction={handleVehiclelist} vehicleData={vehicleData} />
                                              {/*<VehicleListView handleAction={handleVehiclelist} vehicleData={vehicleactivities} />*/}
                                        </Col>}
                                      </Row>

                                        <div className='view-vehiclelist-action mt-4'>
                                                <div className="col-md-12 d-flex justify-content-center pb-3">
                                                      <Button type="button" variant="primary custom-sbm-btncls view-vehiclelist-btn" onClick={() => handleVehiclelist('open')}>
                                                        <img src={eyeIcon} className='action-icons eye-icon' alt='eyeIcon' /> View Vehicle List
                                                      </Button>
                                              </div>
                                        </div>
                                   </div>
                              </div>

                              {/* Overlay Spinner */}
                              {(vchlLoading || isLoading) && (
                              <div className="table-overlay">
                                    <Spinner animation="border" className="table-spinner" />
                              </div>
                              )}
                        </CardBody>
                  </Card>

            </div>      
          </Container>
          </div>);
}